import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField, SelectFormField, CustomFormInput } from '../../../../../utils/FormFields';
import CircularProggess from '../../../../CircularProgress/CircularProgress';
import { BankAccountStatus } from '../../../../Profile/Account/types';

function BankAccountsTab({
  account, changedAccount, showChanges, currencies, fetchFile
}) {
  const editBankAccount = changedAccount.BankAccounts[0];
  let compareBankAccount;
  account.BankAccounts.map((b) => {
    if (parseInt(b.BankAccountItemId, 10) === parseInt(editBankAccount.BankAccountItemId, 10)) {
      compareBankAccount = b;
    }
    return {};
  });
  let color = 'black';
  if (showChanges) {
    if (compareBankAccount && editBankAccount.DeleteBankAccount) {
      color = 'red';
    } else if (compareBankAccount) {
      color = '#36a9e1';
    } else {
      color = 'green';
    }
  }

  const getFile = (file) => {
    const body = {
      fileId: file.ArchiveTemporalFileId
    }
    fetchFile(body, (response) => {
      var a = document.createElement('A');
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges
          ? (
            <React.Fragment>
              {editBankAccount.BankAccountItemId > 0
                ? (
                  <React.Fragment>
                    {editBankAccount.DeleteBankAccount ? 'Delete Bank Account' : 'Edit Bank Account'}
                  </React.Fragment>
                )
                : 'New Bank Account'}
            </React.Fragment>
          )
          : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {!editBankAccount.DeleteBankAccount
              && (
                <FormToShow
                  bankAccount={editBankAccount}
                  refBankAcc={compareBankAccount}
                  currencies={currencies}
                  getFile = {getFile}
                />
              )}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareBankAccount
              && (
                <FormToShow
                  bankAccount={compareBankAccount}
                  currencies={currencies}
                  getFile = {getFile}
                />
              )}
          </FormGroup>
        )}
    </Form>
  );
}

BankAccountsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
  currencies: PropTypes.array,
  fetchFile: PropTypes.func
};

BankAccountsTab.defaultProps = {
  currencies: undefined,
};

export default BankAccountsTab;

const FormToShow = ({ bankAccount, refBankAcc, currencies, getFile }) => (
  <React.Fragment>
    {bankAccount.BankAccountItemId > 0 && (
      <FormField
        name="BankAccountItemId"
        value={bankAccount.BankAccountItemId}
        label="Id"
      />
    )}
    <FormField
      name="BankAccountName"
      value={bankAccount.BankAccountName}
      label="Name"
      changedColor={refBankAcc && bankAccount.BankAccountName !== refBankAcc.BankAccountName}
    />
    <FormField
      name="BankAccountPersonalName"
      value={bankAccount.BankAccountPersonalName}
      label="Personal Name"
      changedColor={refBankAcc
        && bankAccount.BankAccountPersonalName !== refBankAcc.BankAccountPersonalName}
    />
    <FormField
      name="BankAccountHolders"
      value={bankAccount.BankAccountHolders}
      label="Holders"
      changedColor={refBankAcc && bankAccount.BankAccountHolders !== refBankAcc.BankAccountHolders}
    />
    <FormField
      name="BankAccountBranch"
      value={bankAccount.BankAccountBranch}
      label="Branch"
      changedColor={refBankAcc
        && parseInt(bankAccount.BankAccountBranch, 10)
        !== parseInt(refBankAcc.BankAccountBranch, 10)}
      type="number"
      dataTypeDecimalName="currency"
    />
    <FormField
      name="BankAccountNumber"
      value={bankAccount.BankAccountNumber}
      label="Number"
      changedColor={refBankAcc
        && parseInt(bankAccount.BankAccountNumber, 10)
        !== parseInt(refBankAcc.BankAccountNumber, 10)}
    />
    <FormField
      name="BankAccountType"
      value={bankAccount.BankAccountType}
      label="Type"
      changedColor={refBankAcc
        && bankAccount.BankAccountType !== refBankAcc.BankAccountType}
    />
    {currencies ? (
      <SelectFormField
        label="Currency"
        changedColor={refBankAcc
          && parseInt(bankAccount.BankAccountCurrency, 10)
          !== parseInt(refBankAcc.BankAccountCurrency, 10)}
        selectItems={currencies}
        getSelectItemId={(i) => i.currencyId}
        getSelectItemName={(i) => i.currencyISO}
        value={bankAccount.BankAccountCurrency}
        name=""
      />
    ) : <CircularProggess sm />}
    <FormField
      name=""
      value={bankAccount.BankAccountIsDepositInterest ? 'Yes' : 'No'}
      label="Default Instruction: "
      changedColor={refBankAcc
        && bankAccount.BankAccountIsDepositInterest !== refBankAcc.BankAccountIsDepositInterest}
    />
    <FormField
      name=""
      value={bankAccount.BankAccountFundIncomesOnly ? 'Yes' : 'No'}
      label="Fund Incomes only: "
      changedColor={refBankAcc
        && bankAccount.BankAccountFundIncomesOnly !== refBankAcc.BankAccountFundIncomesOnly}
    />
    <FormField
      name="BankAccountObs"
      value={bankAccount.BankAccountObs}
      label="Observation"
      changedColor={refBankAcc
        && bankAccount.BankAccountObs !== refBankAcc.BankAccountObs}
      type="textarea"
    />
    <SelectFormField
        label="Status"
        changedColor={refBankAcc
          && bankAccount.BankAccountStatus !== refBankAcc.BankAccountStatus}
          selectItems={Object.keys(BankAccountStatus)}
        getSelectItemId={i => i}
        getSelectItemName={i => BankAccountStatus[i]}
        value={bankAccount.BankAccountStatus}
        name=""
      />
     
    {bankAccount.Archives !== undefined  && bankAccount.Archives.map((item) => (
      <CustomFormInput label="File">
      
      {item.ArchiveTemporalFileId > 0 ? 
        <a onClick= {() => getFile(item)} style = {{cursor:'pointer'}}>
          {`${item.ArchiveName}.${item.ArchiveExtension}`}
        </a> 
      : /* Este es el caso para las alertas que tienen los blobs en el objeto item */
        <a href={`data:application/octet-stream;base64,${item.ArchiveBlob}`} download={`${item.ArchiveName}.${item.ArchiveExtension}`}>
          {`${item.ArchiveName}.${item.ArchiveExtension}`}
        </a> 
      }
    
   </CustomFormInput>
       ))}
       
  </React.Fragment>
);

FormToShow.propTypes = {
  bankAccount: PropTypes.object.isRequired,
  refBankAcc: PropTypes.object,
  currencies: PropTypes.array,
  getFile: PropTypes.func
};

FormToShow.defaultProps = {
  refBankAcc: undefined,
  currencies: undefined,
};
